import React, { useEffect } from 'react';
import { Trans } from '@lingui/macro';
import Spinner from '@mos-front-components/public/es/components/Spinner/Spinner';
import { createStructuredSelector } from 'reselect';
import { connect } from 'dva';
import Steps from '@mos-front-components/public/es/components/Steps';
import { Heading } from '@mos-cat/typography';

import './FormPage.pcss';
import ApplicantData from '../../components/applicant/ApplicantData/ApplicantData';
import SpouseData from '../../components/spouse/SpouseData/SpouseData';
import FinalStep from '../../components/sendStep/FinalStep/FinalStep';
import ChildrenData from '../../components/children/ChildrenData/ChildrenData';
import {
  getApplicantLivesWithSecondParent,
  isApplicantMarried,
  isAuthAndElkLoading,
} from '../../selectors/applicant';
import ErrorModal from '../../components/layout/ErrorModal/ErrorModal';
import AuthCheck from '../../components/layout/AuthCheck/AuthCheck';
import DraftInfo from '../../components/layout/DraftInfo/DraftInfo';
import DraftInfoTop from '../../components/layout/DraftInfoTop/DraftInfoTop';
import { hasOpenModals } from '../../selectors/modals';
import { draftDownloadError } from '../../selectors/submit';
import DraftWarning from '../../components/layout/DraftWarning/DraftWarning';

interface Props {
  isMarried: boolean;
  isLivingTogether: boolean;
  loading: boolean;
  hasElkData: boolean;
  hasOpenModals: boolean;
  draftDownloadError: boolean;
}

function FormPage({
  isMarried,
  isLivingTogether,
  loading,
  hasElkData,
  hasOpenModals,
  draftDownloadError,
}: Props): JSX.Element {
  const steps = [
    <ApplicantData key="applicant" />,
    (isMarried || isLivingTogether) && <SpouseData key="spouse" />,
    <ChildrenData key="children" />,
    <FinalStep key="consent" />,
  ].filter(Boolean);

  useEffect(() => {
    document.body.style.overflow = hasOpenModals ? 'hidden' : 'auto';
  }, [hasOpenModals]);

  const content = loading ? (
    <div className="FormPage__Spinner">
      <Spinner overlayVisible={false} />
    </div>
  ) : (
    <>
      <Steps collapsible={false} className="FormPage__steps">
        {steps}
      </Steps>
      <DraftInfo />
    </>
  );

  return (
    <div className="FormPage">
      <DraftInfoTop />
      <div className="FormPage__top">
        <Heading className="FormPage__title" level={1}>
          <Trans>
            Присвоение (продление) льготного статуса многодетной семьи города
            Москвы
          </Trans>
        </Heading>
        <div className="FormPage__text">
          <Trans>
            Подать заявление может один из родителей (единственный родитель),
            отчим, мачеха многодетной семьи из числа граждан РФ, иностранных
            граждан, лиц без гражданства, имеющих место жительства в городе
            Москве, при условии его фактического совместного проживания с
            детьми, имеющими место жительства в городе Москве.
          </Trans>
        </div>
      </div>
      <div className="FormPage__content">
        {draftDownloadError ? (
          <DraftWarning />
        ) : hasElkData ? (
          content
        ) : (
          <AuthCheck>
            <div className="FormPage__Spinner">
              <Spinner overlayVisible={false} />
            </div>
          </AuthCheck>
        )}
      </div>
      <ErrorModal />
    </div>
  );
}

const mapStateToProps = createStructuredSelector<any, any>({
  hasElkData: ({ elk }) => !!elk.snils,
  isMarried: isApplicantMarried,
  isLivingTogether: getApplicantLivesWithSecondParent,
  loading: isAuthAndElkLoading,
  draftDownloadError: draftDownloadError,
  hasOpenModals,
});

export default connect(mapStateToProps)(FormPage);
